import { LogoVip } from '@pcln/vip'
import { Box, Button, Card, Flex, Hide, Image, List, Text } from 'pcln-design-system'
import React from 'react'

function SilhouetteCard({
  labelText = 'family',
  title = 'Unlock bigger savings 5x faster with a VIP Family account',
  firstTextLine = (
    <Text fontSize={1}>
      With a VIP Family account, everyone can unlock bigger savings{' '}
      <Text.span fontWeight='bold'>5x faster.</Text.span>
    </Text>
  ),
  benefitsList = [
    // eslint-disable-next-line react/jsx-key
    <Text>
      {"Each family member's booking contributes to the "}
      <Text.span fontWeight='bold'>{"entire family's VIP status"}</Text.span> for both this year and next year
    </Text>,
    // eslint-disable-next-line react/jsx-key
    <Text>
      You <Text.span fontWeight='bold'>{"earn savings even when you're not traveling"}</Text.span>
      {", thanks to your family members' bookings"}
    </Text>,
    // eslint-disable-next-line react/jsx-key
    <Text>
      {"And when it's your turn to get away, they'll be earning "}
      <Text.span fontWeight='bold'>bigger savings</Text.span>, too
    </Text>,
  ],
  lastTextLine = (
    <Text fontSize={1}>
      Add up to five friends or family to your VIP Family account and{' '}
      <Text.span fontWeight='bold'>supercharge your savings!</Text.span>
    </Text>
  ),
  onClick,
  callToActionText = 'Create your VIP Family',
  imgSrc = 'https://s1.pclncdn.com/design-assets/vip-family/Group_2_yellow.png',
  imgAlt = 'Happy family on a road trip in car, front passenger POV',
}) {
  return (
    <Card borderRadius='xl' color='background.lightest' borderColor='border.tint' overflow='hidden'>
      <Hide xl xxl>
        <Flex>
          <Image src={`${imgSrc}?opto&webp=true`} alt={imgAlt} height='123px' />
          <Flex flexDirection='column' p={3}>
            {VipLogoAndLabel(labelText)}
            {TitleText(3, title)}
          </Flex>
        </Flex>
        <Box px={3}>
          {firstTextLine}
          {FamilyBenefitsList(benefitsList)}
          {lastTextLine}
        </Box>
        <Box p={3}>
          <Button type='button' width={1} onClick={onClick} target='_blank'>
            {callToActionText}
          </Button>
        </Box>
      </Hide>
      <Hide xs sm md lg>
        <Flex>
          <Image src={`${imgSrc}?opto&webp=true`} alt={imgAlt} width='340px' height='357px' />
          <Flex flexDirection='column' p={4}>
            {VipLogoAndLabel(labelText)}
            {TitleText('26px', title)}
            {firstTextLine}
            {FamilyBenefitsList(benefitsList)}
            {lastTextLine}
            <Flex py={3}>
              <Button onClick={onClick} target='_blank'>
                {callToActionText}
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Hide>
    </Card>
  )
}

function VipLogoAndLabel(labelText) {
  return (
    <Flex flexDirection='row'>
      <LogoVip variation='vip' fontSize='30px' title='Priceline VIP logo' />
      <Flex alignItems='center'>
        <Text textTransform='uppercase' ml={2} fontSize='15px' fontWeight='bold' color='primary.shade'>
          {labelText}
        </Text>
      </Flex>
    </Flex>
  )
}

function TitleText(titleFontSize, title) {
  return (
    <Text fontWeight='bold' fontSize={titleFontSize} py={2} color='text'>
      {title}
    </Text>
  )
}

function FamilyBenefitsList(benefits) {
  return (
    <List.ul aria-label='benefits' indentSize='sm' fontSize={1}>
      {benefits.map((benefit, index) => (
        <li key={index}>{benefit}</li>
      ))}
    </List.ul>
  )
}

export default SilhouetteCard
